import { ErrorCodes } from '@/constants/errorCodes';
import type { StoreError } from '@/types/storeError.interface';
import { isErrorCode } from '@/utils/errorHelpers';

/** True when failed validation attempts locked the invitation behind a key. */
export const isInvitationLocked = (error: StoreError | null | undefined) =>
  isErrorCode(error, ErrorCodes.AUTH_INVITATION_LOCKED);
